<mcrit-time-table-week-header
  [year]="year"
  [weekNumber]="weekNumber"
  (change)="updateDate($event)">
</mcrit-time-table-week-header>
<mcrit-time-table-week-body
  [firstDayWeek]="firstDayWeek"
  [tipus]="tipus"
  [projectAggregates]="projectAggregates"
  (requestDayEdit)="openDayEdit($event)">
</mcrit-time-table-week-body>
<mcrit-time-table-dialog #dialog
  [selectedDay]="selectedDay"
  [projectId]="selectedProjectId"
  [tasks]="selectedDayTasks"
  (update)="updateTaskRequest($event)">
</mcrit-time-table-dialog>
